<div class="corp-result-wrapper">
  <div class="corp-result-card">

    <!-- Título -->
    <div class="corp-result-header">
      <h4 class="corp-result-main-title">Resultado del Pago</h4>
    </div>

    <!-- Esperando respuesta -->
    <div *ngIf="respuestaPagoCarga" class="corp-result-loading">
      <div class="corp-spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <p>Esperando respuesta del pago...</p>
    </div>

    <!-- Respuesta recibida -->
    <div *ngIf="respuestaPago" class="corp-result-body">

      <!-- Ícono y mensaje principal -->
      <div class="corp-result-status" [ngClass]="respuestaPago.estado === 'Procesada' ? 'status-success' : 'status-error'">
        <div class="corp-status-icon">
          <i *ngIf="respuestaPago.estado === 'Procesada'" class="fas fa-check-circle"></i>
          <i *ngIf="respuestaPago.estado !== 'Procesada'" class="fas fa-minus-circle"></i>
        </div>
        <p class="corp-status-text">
          {{ respuestaPago.estado === 'Procesada' ? '¡El pago fue exitoso!' : '¡El pago fue rechazado!' }}
        </p>
      </div>

      <!-- Tabla de detalles -->
      <div class="corp-result-table">

        <div class="corp-result-row">
          <span class="corp-row-label">Fecha Transacción</span>
          <span class="corp-row-value">{{ respuestaPago.fecha }}</span>
        </div>

        <div class="corp-result-row">
          <span class="corp-row-label">Código Autorización</span>
          <span class="corp-row-value">{{ respuestaPago.codigoAutorizacion || 'N/A' }}</span>
        </div>

        <div class="corp-result-row">
          <span class="corp-row-label">Referencia</span>
          <span class="corp-row-value">{{ respuestaPago.referencia || 'N/A' }}</span>
        </div>

        <div class="corp-result-row">
          <span class="corp-row-label">Monto</span>
          <span class="corp-row-value">{{ formatearMoneda(respuestaPago.monto) }}</span>
        </div>

        <div class="corp-result-row">
          <span class="corp-row-label">Moneda</span>
          <span class="corp-row-value">{{ respuestaPago.moneda }}</span>
        </div>

        <div class="corp-result-row">
          <span class="corp-row-label">Status</span>
          <span class="corp-row-value">
            <span class="corp-badge" [ngClass]="respuestaPago.estado === 'Procesada' ? 'badge-success' : 'badge-error'">
              {{ respuestaPago.estado }}
            </span>
          </span>
        </div>

        <div class="corp-result-row">
          <span class="corp-row-label">Mensaje transacción</span>
          <span class="corp-row-value">{{ respuestaPago.mensaje }}</span>
        </div>

      </div>
    </div>

    <!-- Botón Finalizar -->
    <div class="corp-result-actions">
      <button class="corp-btn corp-btn-primary" (click)="cerrarVentana()">
        <i class="fas fa-check me-2"></i> Finalizar Pago
      </button>
    </div>

  </div>
</div>